import React, { useState, useEffect } from "react";
import {
  FolderOpenOutlined,
  EditOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import Notiflix from "notiflix";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";

import {
  Table,
  Tooltip,
  Button,
  Form,
  Spin,
  Row,
  Col,
  Input,
  Modal,
  Divider,
  Space,
  Select,
  DatePicker,
  Descriptions,
  Typography,
} from "antd";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";
import dayjs from "dayjs";
import { elements } from "chart.js";
import DownloadTableButtons from "../../../../../../components/DownloadTableButtons";

const dateFormat = "YYYY-MM-DD";

const { Text } = Typography;

const Transactions = (props) => {
  const { transactionsList, state, userData } = props;
  const navigate = useNavigate();

  const [newTransactionsList, setNewTransactionsList] =
    useState(transactionsList);

  function handleJournalEntryView(objParam) {
    navigate("/view-journal-entries", {
      state: { ...state, transactionId: objParam.id },
    });
  }

  const columns = [
    {
      title: "ID",
      render: (_, record) => (
        <>
          {record.manuallyReversed ? (
            <Text className="strikeoff">{record.id}</Text>
          ) : (
            <Text>{record.id}</Text>
          )}
        </>
      ),
    },
    {
      title: "Office",
      render: (_, record) => (
        <>
          {record.manuallyReversed ? (
            <Text className="strikeoff">{record.office}</Text>
          ) : (
            <Text>{record.office}</Text>
          )}
        </>
      ),
    },
    {
      title: "Transaction Date",
      render: (_, record) => (
        <>
          {record.manuallyReversed ? (
            <Text className="strikeoff">{record.transactionDate}</Text>
          ) : (
            <Text>{record.transactionDate}</Text>
          )}
        </>
      ),
    },
    {
      title: "Transaction Type",
      render: (_, record) => (
        <>
          {record.manuallyReversed ? (
            <Text className="strikeoff">{record.transactionType}</Text>
          ) : (
            <Text>{record.transactionType}</Text>
          )}
        </>
      ),
    },
    {
      title: "Amount",
      render: (_, record) => (
        <>
          {record.manuallyReversed ? (
            <Text className="strikeoff">{record.amount.toLocaleString()}</Text>
          ) : (
            <Text>{record.amount.toLocaleString()}</Text>
          )}
        </>
      ),
    },
    {
      title: "Breakdown",
      children: [
        {
          title: "Principal",
          render: (_, record) => (
            <>
              {record.manuallyReversed ? (
                <Text className="strikeoff">
                  {record.principal.toLocaleString()}
                </Text>
              ) : (
                <Text>{record.principal.toLocaleString()}</Text>
              )}
            </>
          ),
        },
        {
          title: "Interest",
          render: (_, record) => (
            <>
              {record.manuallyReversed ? (
                <Text className="strikeoff">{record.interest}</Text>
              ) : (
                <Text>{record.interest}</Text>
              )}
            </>
          ),
        },
        {
          title: "Fees",
          render: (_, record) => (
            <>
              {record.manuallyReversed ? (
                <Text className="strikeoff">{record.fees}</Text>
              ) : (
                <Text>{record.fees}</Text>
              )}
            </>
          ),
        },
        {
          title: "Penalties",
          render: (_, record) => (
            <>
              {record.manuallyReversed ? (
                <Text className="strikeoff">{record.penalties}</Text>
              ) : (
                <Text>{record.penalties}</Text>
              )}
            </>
          ),
        },
      ],
    },
    {
      title: "Loan Balance",
      render: (_, record) => (
        <>
          {record.manuallyReversed ? (
            <Text className="strikeoff">
              {record.loanBalance.toLocaleString()}
            </Text>
          ) : (
            <Text>{record.loanBalance.toLocaleString()}</Text>
          )}
        </>
      ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <DetailTransactions
            currentCustomerObj={state}
            userData={userData}
            transactionObj={record}
          />
          &nbsp;
          {BOM.HasPermission("ADJUST_LOAN") && (
            <EditTransactions
              currentCustomerObj={state}
              userData={userData}
              transactionObj={record}
            />
          )}
          &nbsp;
          {BOM.HasPermission("READ_JOURNALENTRY") && (
            <Tooltip title={`View Journal Entries`}>
              <Button
                type="primary"
                icon={<EyeOutlined />}
                onClick={() => handleJournalEntryView(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handleViewJournalEntry = () => {
    navigate("/search-journal-entries", { state: state });
  };

  function handlechangeAccruals(param) {
    const accrual = "Accrual";

    switch (param) {
      case true:
        const nonAccruals = transactionsList.filter(
          (element) => element.transactionType !== accrual
        );
        setNewTransactionsList(nonAccruals);
        break;
      case false:
        setNewTransactionsList(transactionsList);
        break;

      default:
        break;
    }
  }

  return (
    <>
      <Button
        type="primary"
        className="of-primaryBtnColor"
        onClick={handleViewJournalEntry}
        shape="round"
      >
        <FolderOpenOutlined />
        &nbsp;{labelConfig.viewJournalEntries}
      </Button>

      <Divider style={{ marginTop: 10, marginBottom: 30 }} />

      <Form
      // layout="vertical"
      >
        {transactionsList.length > 0 && (
          <>
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.hideAccruals} name="hideAccruals">
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.hideAccruals}`,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    onChange={handlechangeAccruals}
                  />{" "}
                </Form.Item>
              </Col>

              <DownloadTableButtons
                downloadData={newTransactionsList}
                columns={columns}
                fileName={"Transactions List"}
              />
            </Row>

            <Table columns={columns} dataSource={newTransactionsList} />
          </>
        )}
      </Form>
    </>
  );
};

export default Transactions;

const DetailTransactions = (props) => {
  const { currentCustomerObj, userData, transactionObj } = props;

  const { session } = userData;

  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [transactionsDetail, setTransactionsDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const items = [
    {
      label: labelConfig.principalpaymentdetail,
      children: `${transactionsDetail.currency?.displaySymbol} ${transactionsDetail.principalPortion}.00`,
    },
    {
      label: labelConfig.interestspayment,
      children: `${transactionsDetail.currency?.displaySymbol} ${transactionsDetail.interestPortion}.00`,
    },
    {
      label: labelConfig.charges,
      children:
        transactionsDetail?.type?.chargePayment === true ? "True" : "False",
    },
    {
      label: labelConfig.createChargeLoanTest,
      children: "-",
    },
  ];

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.LoanAccounts}/${currentCustomerObj.id}/transactions/${transactionObj.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setTransactionsDetail(objDetail);

        setInputField([
          {
            name: labelConfig.transactionId,
            value: objDetail?.id,
            type: "general",
          },
          {
            name: labelConfig.transactionType,
            value: objDetail?.type?.value,
            type: "general",
          },
          {
            name: labelConfig.date,
            value: BOM.FormatArrayDate(objDetail?.date),
            type: "general",
          },

          {
            name: labelConfig.currency,
            value: objDetail?.currency?.name,
            type: "general",
          },
          {
            name: labelConfig.amount,
            value: objDetail.amount,
            type: "general",
          },

          {
            name: labelConfig.paymentDetail,
            value: objDetail?.paymentDetailData?.paymentType?.name,
            type: "payment",
          },
        ]);

        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getDetailById();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onUndoTransaction = (key) => {
    const formValues = {};

    formValues.transactionAmount = key?.amount;
    formValues.transactionDate = BOM.DateTime(key.date, "only-date");
    formValues.dateFormat = "dd MMMM yyyy";

    let action = "Undo ";
    let label = "Transaction";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const params = {
          command: "undo",
        };
        const url = `${apiConfig.LoanAccounts}/${currentCustomerObj.id}/transactions/${transactionObj.id}`;

        const body = {
          method: "POST",
          locale: "en",
          ...formValues,
          session,
          params,
        };

        // message.warning(
        //   "Close or Re-Open module is not ready require some works from the backend"
        // );
        // return;
        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.undoTransactionMsg);

            // close modal
            setIsModalOpen(false);

            //refresh the list
            // refreshList();

            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      }
    );
  };

  return (
    <>
      <Tooltip title={`View Detail`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Transaction Detail"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Form layout="vertical" form={useForm}>
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Space size="small">
                {BOM.HasPermission("ADJUST_LOAN") && (
                  <Button
                    type="primary"
                    shape="round"
                    className="of-primaryBtnColor"
                    onClick={() => onUndoTransaction(transactionsDetail)}
                    danger={true}
                  >
                    Undo
                  </Button>
                )}
              </Space>
            </div>
            <Row>
              <Divider orientation="left">{labelConfig.generalInfo}</Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "general" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>

            <Row>
              <Descriptions
                bordered
                column={{
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 2,
                  xl: 2,
                  xxl: 2,
                }}
                style={{ marginTop: 10, marginBottom: 20 }}
                items={items}
              />
            </Row>
            <Row>
              <Divider orientation="left">
                {labelConfig.paymentInformation}
              </Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "payment" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

const EditTransactions = (props) => {
  const { currentCustomerObj, userData, transactionObj } = props;

  const { session } = userData;

  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [paymentTypesData, setPaymentTypesData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  function getTemplate() {
    const params = {
      template: true,
    };
    const url = `${apiConfig.LoanAccounts}/${currentCustomerObj.id}/transactions/${transactionObj.id}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempPaymentTypes = [];

        objDetail?.paymentTypeOptions.forEach((element) => {
          tempPaymentTypes.push({
            value: element.id,
            label: element.name,
          });
        });

        setPaymentTypesData(tempPaymentTypes);

        useForm.setFieldsValue({
          transactionDate: dayjs(
            BOM.FormatArrayDate(objDetail?.date),
            dateFormat
          ),
          transactionAmount: objDetail?.amount,
          paymentTypeId: objDetail?.paymentDetailData?.paymentType?.name,
        });

        setIsLoading(false);
      }
    });
  }

  const showModal = () => {
    setIsModalOpen(true);
    getTemplate();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    const params = {
      command: "modify",
    };
    const url = `${apiConfig.LoanAccounts}/${currentCustomerObj.id}/transactions/${transactionObj.id}`;

    formValues.transactionDate = BOM.DateTime(
      formValues.transactionDate,
      "only-date"
    );

    formValues.dateFormat = "dd MMMM yyyy";

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
      params,
    };

    // console.log(body); return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.editTransactionMsg);

        // close modal
        setIsModalOpen(false);

        //refresh the list
        //  refreshList();

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Tooltip title={`Edit`}>
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Edit Transaction"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmit}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left">{labelConfig.generalInfo}</Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.transactionDate}
                name="transactionDate"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.transactionDate),
                  },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.transactionAmount}
                name="transactionAmount"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.transactionAmount),
                  },
                ]}
              >
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.transactionAmount
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                disabled
                label={labelConfig.paymentTypes}
                name="paymentTypeId"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.paymentTypes} *`,
                    "select"
                  )}
                  options={paymentTypesData}
                  showSearch
                />
              </Form.Item>
            </Col>

            <Divider orientation="left">{`${labelConfig.paymentDetail}s`}</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.accountNumber} name="accountNumber">
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.accountNumber
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.chequeNumber} name="chequeNumber">
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.chequeNumber
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.routingCode} name="routingCode">
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.routingCode
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.receiptNumber} name="receiptNumber">
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.receiptNumber
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.bankNumber} name="bankNumber">
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.bankNumber)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
